import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { useStudentEventHistory } from "@/hooks/events/useStudentEventHistory";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  studentCode: string | null;
  studentKind: "fs" | "esc" | "kn" | null;
  studentName?: string | null;
}

export const StudentEventHistoryDialog = ({ open, onOpenChange, studentCode, studentKind, studentName }: Props) => {
  const { data: rows = [], isLoading } = useStudentEventHistory(
    open ? studentCode : null,
    open ? studentKind : null
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>ประวัติการเข้าร่วม Event {studentName ? `– ${studentName}` : ""}</DialogTitle>
        </DialogHeader>
        <div className="border rounded-md">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Event</TableHead>
                <TableHead>วันที่จัด</TableHead>
                <TableHead>เวลาที่ลงทะเบียน</TableHead>
                <TableHead>สถานะ</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading && (
                <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground">กำลังโหลด...</TableCell></TableRow>
              )}
              {!isLoading && rows.length === 0 && (
                <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground">ไม่มีประวัติ</TableCell></TableRow>
              )}
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>
                    <div className="font-medium">{r.event_name ?? "-"}</div>
                    {r.event_location && (
                      <div className="text-xs text-muted-foreground">{r.event_location}</div>
                    )}
                  </TableCell>
                  <TableCell className="text-sm">
                    {r.event_start_at ? format(new Date(r.event_start_at), "d MMM yyyy HH:mm") : "-"}
                  </TableCell>
                  <TableCell className="text-sm">
                    {format(new Date(r.assigned_at), "d MMM yyyy HH:mm")}
                  </TableCell>
                  <TableCell>
                    {r.status === "active" ? (
                      <Badge className="bg-green-600 hover:bg-green-600">ลงทะเบียน</Badge>
                    ) : (
                      <Badge variant="secondary">ยกเลิก</Badge>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};
